import { React } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/nav/NavBar'
import { useForm } from 'react-hook-form';
import Footer from '../../components/footer/Footer'
import SideMenu from '../../components/ProfileSideMenu/SideMenu'
import Vector from '../../assets/images/Vector.svg';
import { useAuth } from '../../Context/AuthContext';

export default function EditPassword() {
    const form = useForm();
    const { login } = useAuth();

    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
    } = form;

    const onSubmit = async (data) => {
        const { password } = data;
        console.log(password);
        const email = localStorage.getItem('email');
        let result = await login({ email, password });

        if (result) {
            navigate('/reset-edit-password');

        } else {
            form.reset()
        }



    }

    return (
        <>
            <Navbar />
            <div className='favourit-page-holder'>
                <div className='side-menu-component-holder'>
                    <SideMenu />
                </div>
                <div className='favourite-component-holder'>

                    <Link className='page-name-holder' to={'/profile-settings'}>
                        <img className='edit-icon left-arrow' src={Vector} alt='arrow-icon' />
                        <p className='edit-link'>Edit Password</p>
                    </Link>
                    <div className='edit-password-holder' >
                        <form className='current-password-holder' onSubmit={handleSubmit(onSubmit)}>
                            <div className='edit-name'>
                                <label className='edit-label'>Current Password</label>
                                <input
                                    className='edit-input'
                                    type="password"
                                    placeholder="enter your password"
                                    {...register('password', {
                                        required: true,
                                        minLength: 3
                                    })}
                                />
                            </div>

                            <div className='save-btn-holder edit-password-page'>
                                <button className='save-button ' type="submit">Submit</button>
                            </div>
                        </form>


                    </div>


                </div>
            </div>
            <Footer />
        </>
    )
}
